module.exports = {
    EventFamily: {
        ITM: 'ITM'
    },
    EventAction: {
        ACTN: 'ACTN'
    },
    ActionKind: {
        VIEW: 'VIEW',
        ZOOM: 'ZOOM',
        HSCROLL: 'HSCROLL',
        SELECT: 'SELECT',
        CLICK: 'CLICK',
        UNSELECT: 'UNSELECT',
        ZOOMIN: 'ZOOMIN',
        ZOOMOUT: 'ZOOMOUT',
        ROTATE: 'ROTATE',
        SHOWDIALOG: 'SHOWDIALOG',
        HIDEDIALOG: 'HIDEDIALOG',
        DATA_ENTRY: 'DATA_ENTRY'
    },
    TrackingService: {
        PULSAR: 'pulsar'
    },
    State: {
        ENTRY: 'entry',
        ACTIVE: 'active'
    }
};
